import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
/**
 *
 * @param {any[]} services
 * @returns {Workbook}
 */
export const exportExcel = async (services) => {
  services.forEach((service, index) => {
    if (!service.discount || service.discount === 0)
      service.discount = "SIN DESCUENTO";
    service.order = index + 1;
    service.categoryName = !!service.Category
      ? service.Category.name
      : "SIN CATEGORIA";
  });

  const json = excelHelper.jsonToJson(
    [services],
    [
      {
        name: "SERVICIOS",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "NOMBRE",
          },
          {
            inValue: "categoryName",
            outValue: "CATEGORIA",
          },
          {
            inValue: "price",
            outValue: "PRECIO",
          },
          {
            inValue: "discount",
            outValue: "DESCUENTO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName();
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = () => {
  return (
    formatHelper.toDateYYMMDD(new Date().toUTCString()) +
    "_reporte-general-servicios.xlsx"
  );
};



// WEBPACK FOOTER //
// ./src/scenes/Administration/Service/ServiceList/excel.js